function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "100",
  height: "100"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "fce62701-7ef7-46ae-bf57-5c307ff4057d",
  "data-name": "New Gradient Swatch 5",
  x1: "1.96",
  y1: "11.04",
  x2: "81.14",
  y2: "90.22",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  offset: "0",
  stopColor: "#35abab"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".67",
  stopColor: "#676e96"
}), /*#__PURE__*/React.createElement("stop", {
  offset: ".89",
  stopColor: "#5c568f"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#56488b"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "f0f79ef8-9429-47d3-824b-45f117186c63",
  x1: "19.5",
  y1: "-6.5",
  x2: "98.68",
  y2: "72.68",
  xlinkHref: "#fce62701-7ef7-46ae-bf57-5c307ff4057d"
})), /*#__PURE__*/React.createElement("title", null, "graphic_spot_search"), /*#__PURE__*/React.createElement("g", {
  style: {
    isolation: "isolate"
  }
}, /*#__PURE__*/React.createElement("g", {
  id: "f016d7f1-0e02-49ce-8bd4-7d5b81ef0dd9",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M63 0a37 37 0 00-28.16 61l-5.22 5.22a6 6 0 00-5.76 1.53l-22.09 22a6 6 0 108.46 8.5l22.09-22a6 6 0 001.54-5.78l5.23-5.23A37 37 0 1063 0zm33 38.78c0 .54-.07 1.07-.12 1.61v.2c0 .07 0 .41-.08.61a17.8 17.8 0 01-.25 1.63 7.67 7.67 0 01-.15.81c-.11.54-.23 1.07-.37 1.6a29.83 29.83 0 01-1.25 3.85c-.19.5-.4 1-.63 1.48s-.39.85-.6 1.27a31.13 31.13 0 01-2.12 3.6c-.3.44-.6.87-.92 1.29s-.64.84-1 1.25-.68.81-1 1.2a33.8 33.8 0 01-2.24 2.24c-.39.35-.79.7-1.2 1s-.82.67-1.25 1-.85.62-1.29.92a31.13 31.13 0 01-3.6 2.12 29.42 29.42 0 01-2.75 1.23A29.83 29.83 0 0171.24 69c-.53.15-1.06.27-1.6.37a7.67 7.67 0 01-.81.15c-.54.1-1.08.18-1.63.25l-.61.08h-.2c-.54 0-1.07.1-1.61.12h-.74a32.85 32.85 0 01-15.34-3.23c-.48-.23-1-.47-1.42-.73l-.69-.39c-.46-.26-.92-.54-1.36-.83s-.89-.58-1.32-.89-.85-.62-1.27-.95l-.7-.56-.53-.45c-.59-.51-1.17-1-1.73-1.62s-1.11-1.14-1.62-1.73l-.37-.44a24.5 24.5 0 01-1.59-2.06c-.3-.43-.61-.87-.89-1.32s-.57-.9-.83-1.36l-.38-.69c-.26-.47-.5-.94-.73-1.42A32.85 32.85 0 0130 36v-.74c0-.54.07-1.07.12-1.61v-.2c0-.07 0-.41.08-.61.07-.55.15-1.09.25-1.63a7.67 7.67 0 01.15-.81c.1-.54.22-1.07.37-1.6a29.83 29.83 0 011.25-3.85c.19-.5.4-1 .63-1.48s.39-.85.6-1.27a31.13 31.13 0 012.12-3.6c.3-.44.6-.87.92-1.29s.64-.84 1-1.25.68-.81 1-1.2a33.8 33.8 0 012.24-2.24c.39-.35.79-.7 1.2-1s.82-.67 1.25-1 .85-.62 1.29-.92a31.13 31.13 0 013.6-2.12 29.42 29.42 0 012.75-1.23A29.83 29.83 0 0154.76 5c.53-.14 1.06-.26 1.6-.37a7.67 7.67 0 01.81-.15 17.8 17.8 0 011.63-.25l.61-.08h.2c.54 0 1.07-.1 1.61-.12h.74A32.85 32.85 0 0177.3 7.26c.48.23 1 .47 1.42.73l.69.39c.46.26.91.53 1.36.83s.89.58 1.32.89.86.62 1.27 1 .82.65 1.22 1c.59.51 1.17 1 1.73 1.62s1.11 1.14 1.62 1.73c.36.4.69.8 1 1.22s.65.84 1 1.27.61.87.89 1.32.57.9.83 1.36l.39.69c.26.47.5.94.73 1.42A32.85 32.85 0 0196 38v.78z",
  fill: "url(#fce62701-7ef7-46ae-bf57-5c307ff4057d)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63 8a30.41 30.41 0 00-3.16.17 29 29 0 00-25.67 25.67 28.71 28.71 0 006.36 21.47l.91 1.06a28.59 28.59 0 003.35 3.17A29 29 0 0063 66a30.41 30.41 0 003.16-.17A29 29 0 0063 8z",
  fill: "url(#f0f79ef8-9429-47d3-824b-45f117186c63)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M63 8a30.41 30.41 0 00-3.16.17 29 29 0 00-25.67 25.67 28.71 28.71 0 006.36 21.47l.91 1.06a28.59 28.59 0 003.35 3.17A29 29 0 0063 66a30.41 30.41 0 003.16-.17A29 29 0 0063 8z",
  style: {
    mixBlendMode: "multiply"
  },
  fill: "#193138",
  opacity: ".2"
})))));